import React from 'react';
import CustomPopup from '../CustomPopup';
import { IPPHeading, IPPSubHeading } from '../../../library/Heading/Heading';
import IModuleList from '../../../utils/ModuleList/ModuleList.interface';

interface ViewModulesPopupProps {
  show: boolean;
  onClose: () => void;
  ownerName: string;
  modules: IModuleList[];
}

const ViewModulesPopup: React.FC<ViewModulesPopupProps> = ({ show, onClose, ownerName, modules }) => (
  <CustomPopup onClose={onClose} show={show} width="w-41%">
    <div className="px-2 py-2">
      <IPPSubHeading headerText={`Modules assigned to "${ownerName}"`} className="text-lg font-medium mb-4" />
      {modules.length > 0 ? (
        <div className="max-h-[30rem] overflow-y-auto">
          <table className="w-full border-collapse">
            <thead className="bg-[#f8f8f8]">
              <tr className="text-black text-left">
                <th className="font-semibold text-sm uppercase px-4 py-3">Module Name</th>
                <th className="font-semibold text-sm uppercase px-4 py-3">Description</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {modules.map((module) => (
                <tr key={module.moduleName}>
                  <td className="px-4 py-3 text-sm">{module.moduleName}</td>
                  <td className="px-4 py-3 text-sm text-gray-600 italic">{module.moduleInfo || '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="py-8 text-center">
          <IPPHeading headerText="No modules assigned ☹️ !!" className="text-bold" />
        </div>
      )}
    </div>
  </CustomPopup>
);

export default React.memo(ViewModulesPopup);
